// Mocked service for Timoo section. Simulates backend calls with in-memory state.

function delay(ms = 300) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// In-memory mock state
let creditoState = {
  balance: 120.5,
  currency: "EUR",
  threshold: 50,
  max: 200,
  lastTopups: [
    { id: 1, date: "2025-08-01T10:00:00Z", amount: 50.0 },
    { id: 2, date: "2025-07-15T15:30:00Z", amount: 30.0 },
  ],
  history: [
    { id: 101, type: "usage", label: "Remote Hands", value: 25.0, date: "2025-08-10T12:00:00Z" },
    { id: 102, type: "usage", label: "Shipping", value: 10.0, date: "2025-08-09T09:22:00Z" },
    { id: 103, type: "usage", label: "Access DC", value: 5.0, date: "2025-08-08T18:45:00Z" },
  ],
};

let nextTopupId = 3;
let nextHistoryId = 104;

export const TimooService = {
  async getOverview() {
    await delay();
    // Return a high-level summary for the overview page
    const used = Math.max(0, creditoState.max - creditoState.balance);
    return {
      services: [
        { key: "remote_hands", name: "Remote Hands", active: true },
        { key: "shipping", name: "Shipping", active: true },
        { key: "access_dc", name: "Access DC", active: true },
      ],
      credito: {
        balance: creditoState.balance,
        currency: creditoState.currency,
        threshold: creditoState.threshold,
        max: creditoState.max,
        used,
      },
      notices: [
        { id: "n1", text: "This section currently uses mocked data.", level: "info" },
      ],
    };
  },

  async getCredito() {
    await delay();
    return {
      balance: creditoState.balance,
      currency: creditoState.currency,
      threshold: creditoState.threshold,
      max: creditoState.max,
      lastTopups: [...creditoState.lastTopups],
      history: [...creditoState.history],
    };
  },

  async addCredito(amount) {
    await delay();
    const amt = Number(amount) || 0;
    if (amt <= 0) {
      return { ok: false, message: "Invalid amount" };
    }
    creditoState.balance = Math.min(creditoState.max, creditoState.balance + amt);
    const topup = { id: nextTopupId++, date: new Date().toISOString(), amount: amt };
    creditoState.lastTopups.unshift(topup);
    creditoState.history.unshift({ id: nextHistoryId++, type: "topup", label: "Top-up", value: amt, date: topup.date });
    return { ok: true, ...await this.getCredito() };
  },

  async getHistory() {
    await delay();
    return [...creditoState.history];
  },
};
